<template>
	<div>
    <v-card-title>
      <v-text-field 
        v-model="search"
        append-icon="search"
        label="Buscar"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :headers="headers"
      :items="array_docs"
      :options.sync="pagination"
      :server-items-length="total"
      :loading="loading"
      :footer-props="{
        itemsPerPageOptions: [5, 10, 20, 50, 100],
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      class="elevation-1"
    >
      <template v-slot:item.actions="{ item }">
        <!-- firma de flujo o expedientes -->
        <template 
          v-if="$route.name =='expedientes' || item.agrupador_flujo_id > 0">
          <span color="darken-3" v-if="item.estado=='Bloqueado'" class="mr-4" style="margin-left: 20px;">
            <v-icon>mdi-lock-check</v-icon>
            Bloqueado
          </span>
          <v-btn 
            v-else 
            color="warning" 
            fab x-small 
            class="mx-2" 
            title="Firmar" 
            :disabled="item.firma =='N'"
            :to="{ name: 'expediente_documento_edit', params: {opt: 'firmar', id: item.id}}">
            <v-icon>mdi-draw</v-icon>
          </v-btn>
        </template>

        <!-- firma documentos normales -->
        <template v-else>
          <span color="darken-3" v-if="item.estado=='Bloqueado'" class="mr-4" style="margin-left: 20px;">
            <v-icon>mdi-lock-check</v-icon>
            Bloqueado
          </span>
          <v-btn v-else color="warning" 
            fab x-small class="mx-2" 
            title="Firmar"
            :disabled="item.firma =='N'" 
            :to="{ name: 'documento_edit', params: {opt: 'firmar', id: item.id}}">
            <v-icon>mdi-draw</v-icon>
          </v-btn>
        </template>

        <v-btn color="info" fab x-small class="mx-2" title="Visualizar"
          :to="{ name: 'details', params: {id: item.id, firmado: true}}">
          <v-icon>mdi-file-pdf</v-icon>
        </v-btn>

        <v-menu  flat bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn 
              fab 
              x-small 
              class="mx-2" 
              title="Mover"
              v-bind="attrs"
              :loading="item.puntos_canvas"
              @click="getCarpetas(item)"
              v-on="on">
              <v-icon>mdi-folder-outline</v-icon>
            </v-btn>
          </template>

          <v-card
            outlined
            min-width="300"
            :style="`visibility: ${!item.puntos_canvas ? 'visible' : 'hidden' };`"
          >
            <v-treeview
              dense
              v-model="selection"
              :items="menu_items"
              :selection-type="selectionType"
              @input="verSeleccion"
              selectable
              return-object
            >
            <template v-slot:label="{item, open, selected}">
                {{item.nombre}}
            </template>
            </v-treeview>
            <v-divider></v-divider>
           <v-btn small block @click="guardarCarpetas(item)">Aplicar</v-btn>
          </v-card>
        </v-menu>

        <v-btn color="error" fab x-small class="mx-2" title="Eliminar"
          :disabled="item.creado_por != $store.state.user.email"
          @click="deleteDocument(item.id, item.nombre_archivo)">
          <v-icon>mdi-delete-alert-outline</v-icon>
        </v-btn>
        
      </template>

      <template v-slot:item.agrupador_flujo_id="{ item }">
        <v-chip 
          x-small label class="ma-2" 
          :color="item.agrupador_flujo_id > 0 ? 'info' : 'success'" 
          text-color="white">
          {{ item.agrupador_flujo_id > 0 ? 'FLUJO' : 'DOCUMENTO' }}
        </v-chip>
      </template>

    </v-data-table>
  </div>
</template>

<script>

import axios from "axios";

export default {
	props: ['opt',],
  data: function() {
    return {
      search: '',
      carpeta_id: "",
      array_docs: [],
      headers: [
        { text: 'Doc id', sortable: true, value: 'id',},
        { text: 'Documento', sortable: true, value: 'nombre_archivo',},
        { text: 'Creado por', sortable: true, value: 'creado_por',},
        { text: 'Paginas', sortable: true, value: 'paginas',},
        { text: 'Fecha creación', sortable: true, value: 'fecha_creacion_formateada',},
        { text: 'Tipo', sortable: false, value: 'agrupador_flujo_id',},
        { text: 'Acciones', value: 'actions', sortable: false },
      ],
      options: {},
      categories: [],
      total: 0,
      loading: false,
      pagination: {},

      selection: [],
      selectionType: 'independent',
      open: ['public'],
      menu_items: [],
      current_seleccion:[],
    };
  },
  computed: {
    
  },
  watch: {
    pagination: {
      handler () {
        this.getCategoriesByPagination();
      },
      deep: true,
    },
    search: {
      handler () {
        this.getCategoriesByPagination();
      },
      deep: true,
    },
  },
  created () {
    if (this.$route.name == "expedientes" || this.$route.name == "carpeta_personal" || this.$route.name == "carpeta_lote" ) {
      this.carpeta_id = this.$route.params.id;
    } else {
      this.carpeta_id = this.getCarpetaObj(this.opt)[0].id;
    }
  },
  mounted() {
  	console.log(this.opt + " - " + this.carpeta_id);
    this.menu_items = this.$store.state.user.main_menu.concat(this.$store.state.user.menu_personal);
    //console.log(this.pagination);
  },
  methods: {
    getCarpetaObj(name) {
      return this.$store.state.user.main_menu.filter(v => v.link == name);
    },
    getCategoriesByPagination() {
      this.loading = true;

      // get by search keyword
      if (this.search) {
          //let getdoc = axios.get('Paquete/Listar?carpeta_id='+ this.carpeta_id, { 'headers': this.$store.state.user.headers })
          let getdoc = axios.get('Paquete/listar_paginacion?carpeta_id='+this.carpeta_id+'&query='+this.search+'&page='+this.pagination.page+'&per_page='+this.pagination.itemsPerPage, { 'headers': this.$store.state.user.headers })
          return getdoc.then(res => {
            //console.log(res);
            this.array_docs = res.data.items;
            this.total = res.data.total;
          })
          .catch(err => console.log(err.response.data))
          .finally(() => this.loading = false);
      }
      // get by sort option
      if (!this.search && this.pagination.sortBy) {
          const direction = this.pagination.sortDesc[0] ? 'desc' : 'asc';
          //let getdoc = axios.get('Paquete/Listar?carpeta_id='+ this.carpeta_id, { 'headers': this.$store.state.user.headers })
          let getdoc = axios.get('Paquete/listar_paginacion?carpeta_id='+this.carpeta_id+'&direction='+direction+'&sortBy='+this.pagination.sortBy+'&page='+this.pagination.page+'&per_page='+this.pagination.itemsPerPage, { 'headers': this.$store.state.user.headers })
          return getdoc.then(res => {
            //console.log(res);
            this.loading = false;
            this.array_docs = res.data.items;
            this.total = res.data.total;
          })
          .catch(err => console.log(err.response.data))
          .finally(() => this.loading = false);
      } 
      if(!this.search && !this.pagination.sortBy) {
          //let getdoc = axios.get('Paquete/Listar?carpeta_id='+ this.carpeta_id, { 'headers': this.$store.state.user.headers })
          let getdoc = axios.get('Paquete/listar_paginacion?carpeta_id='+this.carpeta_id+'&page='+this.pagination.page+'&per_page='+this.pagination.itemsPerPage, { 'headers': this.$store.state.user.headers })
          return getdoc.then(res => {
            //console.log(res);
            this.array_docs = res.data.items;
            this.total = res.data.total;
          })
          .catch(err => console.log(err.response.data))
          .finally(() => this.loading = false);
      }
    },
    deleteDocument(paquete_id, nombre_archivo) {
      console.log("Eliminar paquete: " + paquete_id);
      let r = confirm("¿Seguro de eliminar el documento " + nombre_archivo + " ?");
      if (r == true) 
      {
        this.$store.dispatch('SET_OVERLAY');
        let item_array = this.array_docs.findIndex(v => v.id == paquete_id);
        let getdoc = axios.delete('Paquete/Eliminar?id='+ paquete_id, { 'headers': this.$store.state.user.headers })
        return getdoc.then((callback) => {
          console.log(callback.status);
          this.$store.dispatch('UNSET_OVERLAY');
          if(callback.status == 200) {
            this.array_docs.splice(item_array, 1);
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'info', text: 'Documento eliminado con éxito.' });
          }else {
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso.' });
          }
        }).catch((error) => {
          this.$store.dispatch('UNSET_OVERLAY');
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo un error en el proceso.' });
          console.log(error.response.data);
        });
      }
    },
    getCarpetas(item)
    {
      let _thisgc = this;
      _thisgc.selection = [];
      _thisgc.current_seleccion = [];
      item.puntos_canvas = true;
      let getdoc = axios.get('Paquete/listar_carpetas?id='+item.id, { 'headers': this.$store.state.user.headers })
      return getdoc.then(res => {
        item.puntos_canvas = false;
        if(res.status == 200) {
          res.data.forEach(function(item, index){
            _thisgc.selection.push(item.carpeta);
            _thisgc.current_seleccion.push(item.carpeta);
          });
        }
      })
      .catch(err => console.log(err))
      .finally(() => console.log("getCarpetas finally"));
    },
    verSeleccion(){
      
    },
    guardarCarpetas(utem) 
    {
      if(this.selection.length == 0){
        this.$store.dispatch('SHOW_ERROR', {show: true, type: 'default', text: 'Debe seleccionar almenos una carpeta' });
        return false;
      }

      let obj_carpetas = [];
      let current_seleccion = this.current_seleccion.map((t) => t.id);
      this.selection.forEach(function(item, i1){
        obj_carpetas.push({"CarpetaId": item.id, "asignado": true});
      });

      current_seleccion.forEach(function(item2, i2){
        let i = obj_carpetas.filter(v => v.CarpetaId == item2);
        if(i.length == 0) {
          obj_carpetas.push({"CarpetaId": item2, "asignado": false});
        }
      });

      utem.puntos_canvas = true;
      let getdoc = axios.post('Paquete/asignar_carpeta', 
        {'PaqueteId':utem.id, 'carpetas':obj_carpetas}, { 'headers': this.$store.state.user.headers }
      )
      return getdoc.then(res => {
        if(res.status == 200){
          this.$store.dispatch('SHOW_ERROR', {show: true, type: 'default', text: 'Completado con éxito' });
        }
        utem.puntos_canvas = false;
      })
      .catch((error) => {
        console.log(error);
        utem.puntos_canvas = false;
      })
      .finally(() => console.log("getCarpetas finally"));
    }
  }
};
</script>